import React from 'react';
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { AppState } from 'store'
import { FooterLinksProps, FooterProps, PhoneNumberProps } from './FooterProps'
import { preparePhoneNumberToHref } from 'common/helpers/helpers'
import useTextContents from 'common/hooks/useTextContents'

import PaykaChatIcon  from 'assets/icons/payka-phone.svg'
import LockIcon  from 'assets/icons/lock-icon.svg'
import './Footer.scss'


/**
 * Komponent wyświetlający nagłówki z linkami do podstron zawierających dokumenty informacyjne.
 * @returns 
 */
const FooterLinks = (props: FooterLinksProps): JSX.Element => {

   const { documentsLinksConfig } = props

   const handleOnClick = (e: React.MouseEvent<HTMLAnchorElement>, link: string) => {
     e.preventDefault() //Blokujemy akcję kliknięcia w przycisk
     window.open(link, '_blank') //Otwieramy pełen link w nowej karcie
   }

   return (
      <div className='footer-links-inner-wrapper'>
         <a href={documentsLinksConfig.privacyPolicy.displayedLink} onClick={(e) => handleOnClick(e, documentsLinksConfig.privacyPolicy.path)} rel="noreferrer" className='privacy-policy'>
            {documentsLinksConfig.privacyPolicy.text}
         </a>
         <a href={documentsLinksConfig.websiteRegulations.displayedLink} onClick={(e) => handleOnClick(e, documentsLinksConfig.websiteRegulations.path)} rel="noreferrer" className='website-regulations'>
            {documentsLinksConfig.websiteRegulations.text}
         </a>
         <a href={documentsLinksConfig.documents.displayedLink} onClick={(e) => handleOnClick(e, documentsLinksConfig.documents.path)} rel="noreferrer" className='docs-to-download'>
            {documentsLinksConfig.documents.text}
         </a>
         <a href={documentsLinksConfig.accessibilityStatement.displayedLink} onClick={(e) => handleOnClick(e, documentsLinksConfig.accessibilityStatement.path)} rel="noreferrer" className='accessibility-statement'>
            {documentsLinksConfig.accessibilityStatement.text}
         </a>
      </div>
   )
}

/**
 * Komponent wyświetlający część stopki z linkiem do strony Paytree oraz tekstem informacyjnym.
 */
const FooterInfo = (): JSX.Element => {
   const footerTextContents = useTextContents()

   return (
      <div className='footer-info-outer-wrapper'>
         <img src={LockIcon} alt='lock'/>
         <p dangerouslySetInnerHTML={{__html: footerTextContents('footer.mainFooterInfoText')}} />
      </div>
   )
}

/**
 * Komponent wyświetlający ikonkę z numerem telefonu, po naciśnięciu której uruchamiana jest odpowiednia aplikacja do wykonywnaia połączeń. 
*/
const PhoneNumber = (props: PhoneNumberProps): JSX.Element | null => {
   if(!props.isPhoneAvailable){
     return null
   }
 
   return (
     <div className='footer-phone-number-wrapper'>
       <a href={preparePhoneNumberToHref(props.phoneNumber)}>
         <img src={PaykaChatIcon} alt="phone-icon" />
         <p className='footer-phone-number'>{props.phoneNumber}</p>
       </a>
     </div>
   )
 }


/**
 * Komponent wyświetlający stopkę aplikacji na podstronach na których została ona przewidziana.
 */ 
const Footer = (props: FooterProps): JSX.Element | null => {

   const footerConfig = useSelector((state: AppState) => state.globalConfigurationState.footerConfig)
   const documentsLinksConfig = useSelector((state: AppState) => state.globalConfigurationState.documentsLinksConfig)

   if(!props.showFooter){
      return null
   }
   
   return (
      <footer className='footer-outer-wrapper'>
         <hr className='footer-separator'/>
         <FooterLinks documentsLinksConfig={documentsLinksConfig} />
         <FooterInfo />
         <PhoneNumber isPhoneAvailable={footerConfig.isPhoneAvailable} phoneNumber={footerConfig.phoneNumber} />
      </footer>
   )
}

export default Footer